import {ApiResource} from 'common/util/model-resource/api-resource';
import {Model} from 'common/util/model-resource/model-resource';
import {PropertyDefinition} from 'common/report/queries/app-api/data-definitions-types';
import {eventPropertyDefinitionsResourceClient} from 'common/report/queries/app-api/property-definitions-client';
import {bulkUpdate, update} from 'common/report/queries/app-api/property-definitions-client';

export class EventPropertyDefinitionsResource extends ApiResource<PropertyDefinition> {
  apiClient = eventPropertyDefinitionsResourceClient;

  async patch(eventName: string, propertyDefUpdate: Partial<PropertyDefinition>): Promise<Model<PropertyDefinition>> {
    const updateResponse = await update(this.buildUpdatePayload(eventName, propertyDefUpdate));
    this.update({[eventName]: updateResponse});
    return this.getOne(eventName);
  }

  async bulkPatch(eventDefUpdates: Record<string, Partial<PropertyDefinition>>): Promise<void> {
    const apiPayload = Object.entries(eventDefUpdates).map(([eventName, eventDefUpdate]) => {
      return this.buildUpdatePayload(eventName, eventDefUpdate);
    });
    await bulkUpdate(apiPayload);

    this.update(eventDefUpdates);
  }

  buildUpdatePayload(eventName: string, eventDefUpdate: Partial<PropertyDefinition>) {
    const eventDef = this.getOne(eventName).value;

    if (!eventDef && eventDefUpdate.id === undefined && eventDefUpdate.name === undefined) {
      throw new Error(
        `Could not find event definition with name ${eventName} in the store. Provide name or id in update payload.`,
      );
    }

    return {
      ...(eventDef?.id ? {id: eventDef?.id} : {}),
      name: eventDef?.name,
      ...eventDefUpdate,
    };
  }
}
